import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  TemplateRef,
} from '@angular/core'
import { coerceBooleanProperty } from '@angular/cdk/coercion'
import { AbstractColumn } from '@shared/components/tables/abstract-column'
import { SETTINGS_FIELDS_REWRITE, SettingsFieldsRewrite } from '@shared/components/tables/settings/fields-rewrite'
import { MatTable } from '@angular/material/table'
import { PlatformSettingsService } from '@app/core/services/platfrom-settings.service'

@Component({
  selector: 'lin-table-column',
  templateUrl: './table-column.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableColumnComponent extends AbstractColumn implements OnInit, OnDestroy {
  currency: string

  @Input() label: string
  @Input() footerContent: string
  @Input() sortId: string
  @Input() currencyColumn: boolean
  @Input() literFraction: boolean
  @Input() sticky: boolean
  @Input() stickyEnd: boolean
  @Input() checkbox: boolean

  @Input()
  get nonSortable(): boolean {
    return this._nonSortable
  }
  set nonSortable(sortable: boolean) {
    this._nonSortable = coerceBooleanProperty(sortable)
  }
  protected _nonSortable: boolean

  @ContentChild(TemplateRef, { static: true }) templateRef: TemplateRef<any>

  constructor(
    @Inject(SETTINGS_FIELDS_REWRITE) @Optional() public fieldsRewrite: SettingsFieldsRewrite,
    @Optional() public table: MatTable<any>,
    private readonly platformSettingsService: PlatformSettingsService,
    public changeDetectorRef: ChangeDetectorRef,
  ) {
    super(table, changeDetectorRef)

    this.fieldsRewrite = fieldsRewrite || {}
    this.currency = platformSettingsService.getClientCurrency().code || 'AUD'
  }
}
